import React, { useEffect, useMemo, useState } from 'react';
import 'react-tabs/style/react-tabs.css';

import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';

import { Stack, Button, Box, Tooltip, IconButton } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import DinnerDiningIcon from '@mui/icons-material/DinnerDining';
import { MaterialReactTable } from 'material-react-table';

import { ThemeProvider } from '@mui/material';
/* tema customizado*/
import tableThemeCustom from '../../form/tableThemeCustom';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';
import { useNavigateParams } from '../../../hooks/useNavigateParams';

//Import Material React Table Translations
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

import Input from '../../form/Input';
import DataList from '../../form/DataList';
import InputNumber from '../../form/InputNumber';
import Select from '../../form/Select';
import Checkbox from '../../form/Checkbox';
import SelectEmpresa from '../../form/SelectEmpresa';

import formStyles from '../../form/Form.module.css';

import { useMRTState } from '../../../hooks/useMRTState';
import { useMRTListController } from '../../../hooks/useMRTController';
/* utils */
import { formatarNumero, formatarNumeroDecimal } from '../../../utils/masks';
import { pickSelectedId, printPdf } from '../../../utils/funcoes';

/* api */
import { relatorios } from '../../../api/relatorios';
import * as DataListAPI from '../../../api/dataList';
import * as EmbalagemAPI from '../../../api/embalagem';
import * as TabelaAPI from '../../../api/tabela';
import * as TabelaPrecoAPI from '../../../api/tabelaPreco';

import * as OperacaoAPI from '../../../api/operacao';

import { podeEditar, podeCancelar, podeImprimir } from '../../../hooks/usePermisionMRT';

function Form({
    token,
    dados,
    setDados,
    handleSubmit,
    btnText,
    caminhoVoltar,
    OptionsEmpresa,
    EnumTipo,
    empresaId,
    empresaIds,
    empresaTabelaId,
}) {
    //grids
    const [itens, setItens] = useState([]);
    const [itensOperacao, setItensOperacao] = useState([]);

    const [OptionsEmbalagem, setOptionsEmbalagem] = useState([]);
    const [OptionsOperacao, setOptionsOperacao] = useState([]);
    const [Operacao, setOperacao] = useState({ descricao: null });
    const [OptionsProduto, setOptionsProduto] = useState([]);
    const [Produto, setProduto] = useState({ descricao: null });

    /* button enable ou disabled */
    const [isDisabled, setIsDisabled] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();

    let createdAt = new Date();

    const tabelaPrecoId = dados?.id ? dados?.id : null;

    const [novoProduto, setNovoProduto] = useState({
        uuid: null,
        Produto,
        empresaId: dados?.empresaId,
        tabelaPrecoId: tabelaPrecoId,
        produtoId: null,
        embalagemId: null,
        fator: 1,
        preco: null,
        precoUnitario: null,
        descricao: null,
        desconto: null,

        domingo: false,
        segunda: false,
        terca: false,
        quarta: false,
        quinta: false,
        sexta: false,
        sabado: false,
        todosDias: true,

        prato: false,
        cafeManha: false,
        almoco: false,
        jantar: false,

        cotacaoId: null,
        createdAt: createdAt, // new Date(),
        ativo: true,
        funcao: 'Adicionar',
    });
    const [novaOperacao, setNovaOperacao] = useState({
        uuid: null,
        Operacao,

        tabelaPrecoId: tabelaPrecoId,
        operacaoId: null,

        ativo: true,
        funcao: 'Adicionar',
    });

    const consultaEmbalagemByProdutoId = async (empresaId, produtoId) => {
        const result = await TabelaAPI.embalagemByProdutoId(empresaId, produtoId);

        if (result && result.request && result.request.status === 404) {
            setFlashMessage(result.response.data.message, 'error');
        } else {
            setOptionsEmbalagem(result);
        }
    };
    const consultaFator = async (token, empresaId, embalagemId) => {
        const result = await TabelaAPI.fatorByEmbalagemId(empresaId, embalagemId);
        setNovoProduto({
            ...novoProduto,
            empresaId: empresaId,
            embalagemId: embalagemId,
            fator: result?.fator || 1,
        });
    };

    // params => empresaId, tabela, id, descricao, condicao, filtro, operacao, funcionarioId
    const consultaDatalist = async (obj) => {
        try {
            const data = await DataListAPI.dataList(obj);
            return data;
        } catch (error) {
            console.error('Erro ao consultar DataList:', error);
            throw error;
        }
    };

    //para obter também pelo codigo de barras
    const consultaDatalistProduto = async (obj) => {
        try {
            const data = await DataListAPI.dataListProduto(obj);
            return data;
        } catch (error) {
            console.error('Erro ao consultar DataList:', error);
            throw error;
        }
    };

    const mrtItens = useMRTState({
        storageKey: `tabelaPreco-itens-${dados?.id || 'novo'}`,
        initialState: {
            pagination: {
                pageIndex: 0,
                pageSize: 5,
            },
            sorting: [],
            columnFilters: [],
            columnFilterFns: {},
            globalFilter: '',
        },
    });

    const mrtOperacoes = useMRTState({
        storageKey: `tabelaPreco-operacoes-${dados?.id || 'novo'}`,
        initialState: {
            pagination: {
                pageIndex: 0,
                pageSize: 5,
            },
            sorting: [],
            columnFilters: [],
            columnFilterFns: {},
            globalFilter: '',
        },
    });

    const fetchItens = async () => {
        if (!dados.id) return;

        mrtItens.setIsLoading(!itens.length);
        mrtItens.setIsRefetching(!!itens.length);
        mrtItens.setIsError(false);

        try {
            const response = await TabelaPrecoAPI.listarProdutos(
                mrtItens.pagination.pageIndex * mrtItens.pagination.pageSize,
                mrtItens.pagination.pageSize,
                JSON.stringify(mrtItens.columnFilters ?? []),
                JSON.stringify(mrtItens.columnFilterFns ?? {}),
                mrtItens.globalFilter ?? '',
                JSON.stringify(mrtItens.sorting ?? []),
                tabelaPrecoId ?? ''
            );

            setItens(response.data.data || []);
            mrtItens.setRowCount(response.data.meta?.totalRowCount || 0);
        } catch (error) {
            console.error(error);
            mrtItens.setIsError(true);
        } finally {
            mrtItens.setIsLoading(false);
            mrtItens.setIsRefetching(false);
        }
    };

    const fetchOperacoes = async () => {
        if (!dados.id) return;

        mrtOperacoes.setIsLoading(!itensOperacao.length);
        mrtOperacoes.setIsRefetching(!!itensOperacao.length);
        mrtOperacoes.setIsError(false);

        try {
            const response = await TabelaPrecoAPI.listarOperacao(
                mrtOperacoes.pagination.pageIndex * mrtOperacoes.pagination.pageSize,
                mrtOperacoes.pagination.pageSize,
                JSON.stringify(mrtOperacoes.columnFilters ?? []),
                JSON.stringify(mrtOperacoes.columnFilterFns ?? {}),
                mrtOperacoes.globalFilter ?? '',
                JSON.stringify(mrtOperacoes.sorting ?? []),
                tabelaPrecoId ?? ''
            );

            setItensOperacao(response.data.data || []);
            mrtOperacoes.setRowCount(response.data.meta?.totalRowCount || 0);
        } catch (error) {
            console.error(error);
            mrtOperacoes.setIsError(true);
        } finally {
            mrtOperacoes.setIsLoading(false);
            mrtOperacoes.setIsRefetching(false);
        }
    };

    useMRTListController({
        mrt: mrtItens,
        contextKey: `tabelaPreco-itens-${dados?.id || 'novo'}`,
        fetchData: fetchItens,
        resolveBoot: () => ({
            sorting: [{ id: 'Produto.descricao', desc: true }],
        }),
    });
    useMRTListController({
        mrt: mrtOperacoes,
        contextKey: `tabelaPreco-operacoes-${dados?.id || 'novo'}`,
        fetchData: fetchOperacoes,
        resolveBoot: () => ({
            sorting: [{ id: 'TabelaPrecoOperacao.descricao', desc: true }],
        }),
    });

    //limpar
    const limparRow = (rotina) => {
        if (rotina === 'produto') {
            setNovoProduto({
                empresaId: dados.empresaId,
                embalagemId: null,
                preco: null,
                precoUnitario: null,
                desconto: null,
                domingo: false,
                segunda: false,
                terca: false,
                quarta: false,
                quinta: false,
                sexta: false,
                sabado: false,
                todosDias: true,
                prato: false,
                cafeManha: false,
                almoco: false,
                jantar: false,
                ativo: true,
                fator: 1,
                funcao: 'Adicionar',
            });
            setProduto({
                id: null,
                descricao: null,
            });
            setOptionsEmbalagem([]);
        }
        if (rotina === 'operacao') {
            setNovaOperacao({
                uuid: null,
                tabelaPrecoId: tabelaPrecoId,
                operacaoId: null,

                ativo: true,
                funcao: 'Adicionar',
            });
            setOperacao({
                id: null,
                descricao: null,
            });
            setOptionsEmbalagem([]);
        }
    };

    const CreateOrEditProduto = async (novoProduto) => {
        try {
            const result = await TabelaPrecoAPI.produto(novoProduto);
            setFlashMessage(result.message, result.type);

            if (result?.status === 200 || result?.type === 'success') {
                limparRow('produto');
                fetchItens();
            }
        } catch (error) {
            console.error(error);
            if (error.response && error.response.status === 422) {
                // Tratar o erro 422, que é específico da validação no servidor
                setFlashMessage('Erro de validação: ' + error.response.data.message);
            } else {
                // Tratar outros erros de rede ou servidor
                setFlashMessage('Ocorreu um erro ao processar a solicitação.', 'error');
            }
        }
    };

    const handleRow = (originalRow, row, funcao, rotina) => {
        // rotina de produtos
        if (rotina === 'produto') {
            const novoProdutoData = {
                uuid: originalRow.uuid,
                Produto: originalRow.Produto,
                Embalagem: originalRow.Embalagem,
                Empresa: originalRow.Empresa,
                empresaId: originalRow.empresaId,
                tabelaPrecoId: originalRow.tabelaPrecoId,
                produtoId: originalRow.produtoId,
                embalagemId: originalRow.embalagemId,
                fator: originalRow.Embalagem.fator,
                preco: originalRow.preco,
                precoUnitario: originalRow.precoUnitario,
                descontoPercentualItemTabela: originalRow.descontoPercentualItemTabela,
                descricao: originalRow.Produto.descricao,

                cotacaoId: originalRow.cotacaoId,
                createdAt: originalRow.createdAt,

                domingo: originalRow.domingo,
                segunda: originalRow.segunda,
                terca: originalRow.terca,
                quarta: originalRow.quarta,
                quinta: originalRow.quinta,
                sexta: originalRow.sexta,
                sabado: originalRow.sabado,
                todosDias: originalRow.todosDias,

                prato: originalRow.prato,
                cafeManha: originalRow.cafeManha,
                almoco: originalRow.almoco,
                jantar: originalRow.jantar,

                ativo: originalRow.ativo,
                funcao: funcao,
                index: row,
            };

            // Atualize o estado do novo produto
            setNovoProduto(novoProdutoData);

            // Atualize o estado do Produto com a descrição
            setProduto({ ...Produto, descricao: originalRow.Produto.descricao });

            //Atualiza o estado da Embalagem
            setOptionsEmbalagem([originalRow.Embalagem]);

            return;
        }
        if (rotina === 'operacao') {
            const novoItemData = {
                uuid: originalRow.uuid,
                Operacao: originalRow.TabelaPrecoOperacao,
                tabelaPrecoId: originalRow.tabelaPrecoId,
                operacaoId: originalRow.operacaoId,

                ativo: originalRow.ativo,
                funcao: funcao,
                index: row,
            };

            // Atualize o estado do novo produto
            setNovaOperacao(novoItemData);

            // Atualize o estado do Produto com a descrição
            setOperacao({ ...Operacao, descricao: originalRow.TabelaPrecoOperacao.descricao });

            return;
        }
    };

    const handleProduto = async () => {
        if (novoProduto.funcao.toLowerCase() === 'editar') {
            if (novoProduto.uuid) {
                CreateOrEditProduto(novoProduto);
            } else {
                setItens((prevItens) => {
                    const novosItens = [...prevItens];
                    novosItens[novoProduto.index] = {
                        ...prevItens[novoProduto.index],
                        ...novoProduto,
                    };
                    return novosItens;
                });
            }
        } else if (novoProduto.funcao.toLowerCase() === 'deletar') {
            if (novoProduto.uuid) {
                try {
                    const response = await TabelaPrecoAPI.deletarProduto(novoProduto.uuid);
                    setFlashMessage(response.data.message, response.data.type);
                } catch (error) {
                    console.error(error);
                    setFlashMessage(error.response.data.message, error.response.data.type);
                }
            } else {
                setItens((prevItens) => {
                    const novosItens = [...prevItens];
                    novosItens.splice(novoProduto.index, 1);
                    return novosItens;
                });
            }
        } else {
            //cadastrar
            if (dados.id) {
                //verificar duplicidade
                const response = await TabelaPrecoAPI.duplicidade(
                    dados.empresaId,
                    novoProduto.tabelaPrecoId,
                    novoProduto.produtoId,
                    novoProduto.embalagemId
                );

                if (response.status === 202) {
                    setFlashMessage('Registo em duplicidade!', 'warning');
                    handleRow(response.data, null, 'Editar', 'produto');
                    return;
                }

                CreateOrEditProduto(novoProduto);
            } else {
                //montar um novo item, Produto, Embalagem, Empresa
                const Embalagem = await EmbalagemAPI.retornaEmbalagemById(novoProduto.embalagemId);
                const Empresa = await TabelaAPI.tabelaById(dados.empresaId, 'Empresa', dados.empresaId);
                const Produto = await TabelaAPI.tabelaById(dados.empresaId, 'Produto', novoProduto.produtoId);

                const novoItemArray = [
                    ...itens,
                    {
                        uuid: novoProduto.uuid,
                        empresaId: novoProduto.empresaId,
                        tabelaPrecoId: novoProduto.tabelaPrecoId,
                        produtoId: novoProduto.produtoId,
                        embalagemId: novoProduto.embalagemId,
                        fator: novoProduto.fator,
                        preco: novoProduto.preco,
                        precoUnitario: novoProduto.precoUnitario,
                        descricao: novoProduto.Produto.descricao,

                        domingo: novoProduto.domingo,
                        segunda: novoProduto.segunda,
                        terca: novoProduto.terca,
                        quarta: novoProduto.quarta,
                        quinta: novoProduto.quinta,
                        sexta: novoProduto.sexta,
                        sabado: novoProduto.sabado,
                        todosDias: novoProduto.todosDias,
                        cafeManha: novoProduto.cafeManha,
                        almoco: novoProduto.almoco,
                        jantar: novoProduto.jantar,

                        ativo: novoProduto.ativo,

                        Embalagem: Embalagem,
                        Empresa: Empresa,
                        Produto: Produto,
                    },
                ];

                setItens(novoItemArray);

                setDados((prev) => ({
                    ...prev,
                    tabelaPrecoItens: novoItemArray,
                }));
            }
        }

        limparRow('produto');

        fetchItens();
    };

    /* Tabela de operações */
    const handleOperacao = async () => {
        if (novaOperacao.funcao.toLowerCase() === 'editar') {
            if (novaOperacao.uuid) {
                CreateOrEditOperacao(novaOperacao);
            } else {
                setItensOperacao((prevItens) => {
                    const novosItens = [...prevItens];
                    novosItens[novaOperacao.index] = {
                        ...prevItens[novaOperacao.index],
                        ...novaOperacao,
                    };
                    return novosItens;
                });
            }
        } else if (novaOperacao.funcao.toLowerCase() === 'deletar') {
            if (novaOperacao.uuid) {
                try {
                    const response = await TabelaPrecoAPI.deletarOperacao(novaOperacao.uuid);
                    setFlashMessage(response.data.message, response.data.type);
                } catch (error) {
                    console.error(error);
                    setFlashMessage(error.response.data.message, error.response.data.type);
                }
            } else {
                setItensOperacao((prevItens) => {
                    const novosItens = [...prevItens];
                    novosItens.splice(novaOperacao.index, 1);
                    return novosItens;
                });
            }
        } else {
            //cadastrar
            if (dados.id) {
                //verificar duplicidade
                const result = await TabelaPrecoAPI.duplicidadeOperacao(novaOperacao.tabelaPrecoId, novaOperacao.operacaoId);

                if (result.status === 202) {
                    setFlashMessage('Registo em duplicidade!', 'warning');
                    handleRow(result.data, null, 'Editar', 'operacao');
                    return;
                }

                CreateOrEditOperacao(novaOperacao);
            } else {
                //montar um novo item, Produto, Embalagem, Empresa
                const Operacao = await OperacaoAPI.operacaoByIdOrUUID(novaOperacao.operacaoId);

                const novoItemArray = [
                    ...itensOperacao,
                    {
                        uuid: novaOperacao.uuid,
                        ativo: novaOperacao.ativo,

                        tabelaPrecoId: novaOperacao.tabelaPrecoId,
                        operacaoId: novaOperacao.operacaoId,

                        TabelaPrecoOperacao: Operacao,
                    },
                ];

                setItensOperacao(novoItemArray);

                setDados((prev) => ({
                    ...prev,
                    TabelaPrecoOperacao: novoItemArray,
                }));
            }
        }

        limparRow('operacao');

        fetchOperacoes();
    };

    const CreateOrEditOperacao = async (novaOperacao) => {
        try {
            const result = await TabelaPrecoAPI.operacao(novaOperacao);
            setFlashMessage(result.message, result.type);

            if (result?.status === 200 || result?.type === 'success') {
                limparRow('operacao');
                fetchOperacoes();
            }
        } catch (error) {
            console.error(error);
            if (error.response && error.response.status === 422) {
                // Tratar o erro 422, que é específico da validação no servidor
                setFlashMessage('Erro de validação: ' + error.response.data.message);
            } else {
                // Tratar outros erros de rede ou servidor
                setFlashMessage('Ocorreu um erro ao processar a solicitação.', 'error');
            }
        }
    };

    useEffect(() => {
        //disabilita botão de adicionar ou editar
        if (!novoProduto.produtoId || !novoProduto.embalagemId || !novoProduto.preco) {
            setIsDisabled(true);
            setIsSubmitting(false);
        } else {
            setIsDisabled(false);
            setIsSubmitting(true);
        }

        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [novoProduto]);

    useEffect(() => {
        //calcula valor unitario
        setNovoProduto((prev) => ({ ...prev, precoUnitario: parseFloat(novoProduto.preco / novoProduto.fator).toFixed(2) }));
    }, [novoProduto.preco, novoProduto.fator]);

    async function handleChange(e) {
        const { name, value, checked, type } = e.target;

        const camposNumericos = [
            'descontoGlobal',
            'percentualMaximoAcrescimo',
            'preco',
            'precoUnitario',
            'descontoPercentualItemTabela',
        ];
        if (name.startsWith('Operacao.')) {
            setOperacao({
                ...Operacao,
                [name.split('.')[1]]: value,
            });

            //carrega o datalist
            const result = await consultaDatalist({
                empresaId: empresaTabelaId,
                tabela: 'Operacao',
                filtro: value,
            });
            setOptionsOperacao(result);
            const selectedId = pickSelectedId(value, result, 'descricao'); // ou passe seu displayField se variar

            setNovaOperacao((prev) => ({
                ...prev,
                operacaoId: selectedId,
                tabelaPrecoId: tabelaPrecoId,
            }));
        } else if (name.startsWith('novoProduto')) {
            const campo = name.split('.')[1];

            if (name.startsWith('novoProduto.descricao')) {
                setProduto({
                    ...Produto,
                    [campo]: value,
                });

                //carrega o datalist
                const filtroProdutoObj = {};
                if (dados.saida) filtroProdutoObj.venda = dados.saida;
                if (dados.entrada) filtroProdutoObj.compra = dados.entrada;

                const result = await consultaDatalistProduto({
                    empresaId: dados.empresaId,
                    ...(Object.keys(filtroProdutoObj).length > 0 && { filtroProduto: filtroProdutoObj ?? {} }),
                    filtro: value,
                });

                setOptionsProduto(result);
                const selectedId = document.querySelector(`datalist option[value="${value}"]`)?.dataset.id || null;
                selectedId && (await consultaEmbalagemByProdutoId(dados.empresaId, selectedId));

                setNovoProduto({
                    ...novoProduto,
                    empresaId: dados.empresaId,
                    tabelaPrecoId: dados.id,
                    produtoId: selectedId ?? null,
                    Produto: { descricao: value },
                });
            } else if (campo === 'embalagemId') {
                setNovoProduto({
                    ...novoProduto,
                    [campo]: value,
                });
                if (value) {
                    await consultaFator(token, dados.empresaId, value);
                }
            } else if (camposNumericos.includes(campo)) {
                const valorFormatado = formatarNumeroDecimal(value);

                setNovoProduto((prev) => {
                    const fator = Number(prev.fator || 1);

                    const next = {
                        ...prev,
                        [campo]: valorFormatado,
                    };

                    if (campo === 'preco') {
                        next.precoUnitario = Number(valorFormatado / fator).toFixed(2);
                    }

                    if (campo === 'precoUnitario') {
                        next.preco = Number(valorFormatado * fator).toFixed(2);
                    }

                    return next;
                });
            } else {
                //set os dados dos checkbox
                setNovoProduto({
                    ...novoProduto,
                    tabelaPrecoId: dados.id,
                    [campo]: type === 'checkbox' ? checked : value,
                });
            }
        } else if (name.startsWith('novaOperacao')) {
        } else {
            if (camposNumericos.includes(name)) {
                setDados((prev) => ({
                    ...prev,
                    [name]: formatarNumeroDecimal(value),
                }));
            } else {
                setDados((prev) => ({
                    ...prev,
                    [name]: type === 'checkbox' ? checked : value,
                }));
            }
        }
    }
    async function handleOnBlur(e) {
        const { name, value } = e.target;
        if (name === 'novoProduto.descricao') {
            setIsSubmitting(false);
        }

        //verifica duplicidade
        if (name === 'descricao' && btnText === 'Cadastrar') {
            const duplicidade = await TabelaAPI.duplicidadeDescricao(dados.empresaId, 'tabelaPreco', value);

            if (duplicidade && duplicidade.uuid) {
                setFlashMessage('Registro em duplicidade!', 'warning');
                return navigate(`/TabelaPrecos/CreateOrEdit`, {
                    ul: 2,
                    li: 33,
                    uuid: duplicidade.uuid,
                    btnText: 'Atualizar',
                });
            }
        }
    }
    async function handleOnFocus(e) {
        const { name } = e.target;
        if (name === 'novoProduto.descricao') {
            setIsSubmitting(true);
        }
    }

    const submit = async (e) => {
        e.preventDefault();
        if (isSubmitting) return; // evita clique duplo

        setIsSubmitting(true);

        try {
            // Aguarda a execução da função de envio (adicione async/await se ela for assíncrona)
            await handleSubmit(dados);
        } catch (error) {
            console.error('Erro ao enviar o formulário:', error);
            // Aqui você pode adicionar um alerta para o usuário se desejar
        } finally {
            // Executado sempre: destrava o botão mesmo se ocorrer um erro
            setIsSubmitting(false);
        }
    };

    /* código da grid */
    const columnsOperacao = useMemo(
        () => [
            {
                id: 'Operacao',
                header: 'Operações vinculadas a tabela de preços',
                columns: [
                    {
                        accessorKey: 'TabelaPrecoOperacao.descricao',
                        header: 'Operação',
                        //you can access a cell in many callback column definition options like this
                        muiTableBodyCellProps: ({ row, cell }) => ({
                            onClick: () => {},
                        }),
                    },
                    {
                        accessorKey: 'TabelaPrecoOperacao.sigla',
                        header: 'Sigla',
                        //you can access a cell in many callback column definition options like this
                        muiTableBodyCellProps: ({ cell }) => ({
                            onClick: () => {},
                        }),
                    },
                ],
            },

            //column definitions...
        ],
        [] //getCommonEditTextFieldProps
    );

    const getColumnsByTipo = (dados) => {
        if (dados?.cardapio) {
            return [
                {
                    id: 'Produtos',
                    header: 'Produtos da Tabela de Preços',
                    columns: [
                        {
                            accessorKey: 'Produto.descricao',
                            header: 'Descrição',
                            //you can access a cell in many callback column definition options like this
                            muiTableBodyCellProps: ({ row, cell }) => ({
                                onClick: () => {
                                    console.info(row.original);
                                },
                            }),
                        },
                        {
                            accessorKey: 'Embalagem.descricao',
                            header: 'Embalagem',
                            //you can access a cell in many callback column definition options like this
                            muiTableBodyCellProps: ({ cell }) => ({
                                onClick: () => {},
                            }),
                        },
                        {
                            accessorKey: 'precoUnitario',
                            header: 'Preço Unitário',
                            muiTableBodyCellProps: {
                                align: 'right',
                            },
                            accessorFn: (row) =>
                                row.precoUnitario === null
                                    ? ''
                                    : 'R$ ' +
                                      parseFloat(row.precoUnitario)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'preco',
                            header: 'Preço Total',
                            muiTableBodyCellProps: {
                                align: 'right',
                            },
                            accessorFn: (row) =>
                                row.preco === null
                                    ? ''
                                    : 'R$ ' +
                                      parseFloat(row.preco)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'Empresa.nomeFantasia',
                            header: 'Empresa',
                        },
                        {
                            accessorKey: 'prato',
                            header: 'Prato',
                            type: 'boolean',
                            columnFilterModeOptions: ['equals'],
                            filterSelectOptions: [
                                { label: 'Todos', value: '' },
                                { label: 'Sim', value: '1' },
                                { label: 'Não', value: '0' },
                            ],
                            filterVariant: 'select',
                            Cell: ({ row }) => {
                                const value = row.original.prato;
                                return <div style={{ textAlign: 'left' }}>{value ? 'Sim' : 'Não'}</div>;
                            },
                        },
                        {
                            accessorKey: 'cafeManha',
                            header: 'Café da Manhã',
                            type: 'boolean',
                            columnFilterModeOptions: ['equals'],
                            filterSelectOptions: [
                                { label: 'Todos', value: '' },
                                { label: 'Sim', value: '1' },
                                { label: 'Não', value: '0' },
                            ],
                            filterVariant: 'select',
                            Cell: ({ row }) => {
                                const value = row.original.cafeManha;
                                return <div style={{ textAlign: 'left' }}>{value ? 'Sim' : 'Não'}</div>;
                            },
                        },
                        {
                            accessorKey: 'almoco',
                            header: 'Almoço',
                            type: 'boolean',
                            columnFilterModeOptions: ['equals'],
                            filterSelectOptions: [
                                { label: 'Todos', value: '' },
                                { label: 'Sim', value: '1' },
                                { label: 'Não', value: '0' },
                            ],
                            filterVariant: 'select',
                            Cell: ({ row }) => {
                                const value = row.original.almoco;
                                return <div style={{ textAlign: 'left' }}>{value ? 'Sim' : 'Não'}</div>;
                            },
                        },
                        {
                            accessorKey: 'jantar',
                            header: 'Jantar',
                            type: 'boolean',
                            columnFilterModeOptions: ['equals'],
                            filterSelectOptions: [
                                { label: 'Todos', value: '' },
                                { label: 'Sim', value: '1' },
                                { label: 'Não', value: '0' },
                            ],
                            filterVariant: 'select',
                            Cell: ({ row }) => {
                                const value = row.original.jantar;
                                return <div style={{ textAlign: 'left' }}>{value ? 'Sim' : 'Não'}</div>;
                            },
                        },
                        {
                            accessorKey: 'ativo',
                            header: 'Ativo',
                            type: 'boolean',
                            columnFilterModeOptions: ['equals'],
                            filterSelectOptions: [
                                { label: 'Todos', value: '' },
                                { label: 'Sim', value: '1' },
                                { label: 'Não', value: '0' },
                            ],
                            filterVariant: 'select',
                            Cell: ({ row }) => {
                                const value = row.original.ativo;
                                return <div style={{ textAlign: 'left' }}>{value ? 'Sim' : 'Não'}</div>;
                            },
                        },
                    ],
                },
            ];
        } else {
            return [
                {
                    id: 'Produtos',
                    header: 'Produtos da Tabela de Preços',
                    columns: [
                        {
                            accessorKey: 'Produto.descricao',
                            header: 'Descrição',
                            //you can access a cell in many callback column definition options like this
                            muiTableBodyCellProps: ({ row, cell }) => ({
                                onClick: () => {
                                    console.info(row.original);
                                },
                            }),
                        },
                        {
                            accessorKey: 'Embalagem.descricao',
                            header: 'Embalagem',
                            //you can access a cell in many callback column definition options like this
                            muiTableBodyCellProps: ({ cell }) => ({
                                onClick: () => {},
                            }),
                        },
                        {
                            accessorKey: 'descontoPercentualItemTabela',
                            header: 'Desconto',
                            muiTableBodyCellProps: {
                                align: 'right',
                            },
                            accessorFn: (row) =>
                                row.descontoPercentualItemTabela === null
                                    ? ''
                                    : parseFloat(row.descontoPercentualItemTabela)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }) + ' %',
                        },
                        {
                            accessorKey: 'precoUnitario',
                            header: 'Preço Unitário',
                            muiTableBodyCellProps: {
                                align: 'right',
                            },
                            accessorFn: (row) =>
                                row.precoUnitario === null
                                    ? ''
                                    : 'R$ ' +
                                      parseFloat(row.precoUnitario)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'preco',
                            header: 'Preço Total',
                            muiTableBodyCellProps: {
                                align: 'right',
                            },
                            accessorFn: (row) =>
                                row.preco === null
                                    ? ''
                                    : 'R$ ' +
                                      parseFloat(row.preco)?.toLocaleString('pt-BR', {
                                          style: 'decimal',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                          minimumIntegerDigits: 1,
                                          useGrouping: true,
                                      }),
                        },
                        {
                            accessorKey: 'Empresa.nomeFantasia',
                            header: 'Empresa',
                        },
                    ],
                },
            ];
        }
    };
    const columns = useMemo(() => {
        return getColumnsByTipo(dados);
    }, [dados]);
    /* modo tema */
    const theme = tableThemeCustom();
    return (
        <div>
            <Tabs>
                <form onSubmit={submit}>
                    <div className={formStyles.stiloPadrao}>
                        <h1>Tabela de Preços</h1>
                        <TabList>
                            <Tab title={'Tabela de Preços'}>Parâmetros</Tab>
                            <Tab title={'Operações vinculadas'}>Operação</Tab>
                        </TabList>
                        <TabPanel>
                            <div>
                                <SelectEmpresa
                                    text="Selecione a Empresa"
                                    name="empresaId"
                                    options={OptionsEmpresa}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.empresaId || ''}
                                    required
                                    notOptNull={true}
                                />
                                <Input
                                    text="Referência"
                                    type="text"
                                    name="referencia"
                                    placeholder="nome simplificado"
                                    inputWidth="100px"
                                    title="Digite a referência da tabela de preço, nome simplificado"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={dados.referencia || ''}
                                    required
                                />
                                <Input
                                    text="Descrição"
                                    type="text"
                                    name="descricao"
                                    placeholder="Nome da Tabela"
                                    title="Digite o nome da tabela de preços"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    inputWidth="200px"
                                    value={dados.descricao || ''}
                                    required
                                />
                                <InputNumber
                                    text="Desconto Global %"
                                    type="text"
                                    name="descontoGlobal"
                                    placeholder="desc %"
                                    inputWidth="100px"
                                    title="Percentual global de desconto permitido nesta tabela, será válido para todos os itens"
                                    handleOnChange={handleChange}
                                    value={dados.descontoGlobal ? formatarNumero(dados.descontoGlobal) : ''}
                                />
                                <InputNumber
                                    text="Preço Máximo %"
                                    type="text"
                                    name="percentualMaximoAcrescimo"
                                    placeholder="max %"
                                    inputWidth="100px"
                                    title="Percentual máximo que pode ser aplicado ao preço de venda, evita erro de digitação e aplicar preço exagerado ao produto"
                                    handleOnChange={handleChange}
                                    value={dados.percentualMaximoAcrescimo ? formatarNumero(dados.percentualMaximoAcrescimo) : ''}
                                />
                                <Checkbox
                                    title="Quando marcada a tabela de preço fica disponível para uso"
                                    text="Liberada"
                                    name="liberada"
                                    handleOnChange={handleChange}
                                    value={dados.liberada}
                                    checked={!!dados.liberada}
                                />
                                <Checkbox
                                    title="Tabela para movimentos de Entrada"
                                    text="Entrada"
                                    name="entrada"
                                    handleOnChange={handleChange}
                                    value={dados.entrada}
                                    checked={!!dados.entrada}
                                />
                                <Checkbox
                                    title="Tabela para movimentos de locação"
                                    text="Locação"
                                    name="locacao"
                                    handleOnChange={handleChange}
                                    value={dados.locacao}
                                    checked={!!dados.locacao}
                                />
                                <Checkbox
                                    title="Tabela para movimentos de Saída"
                                    text="Saída"
                                    name="saida"
                                    handleOnChange={handleChange}
                                    value={dados.saida}
                                    checked={!!dados.saida}
                                />
                                <Checkbox
                                    title="Tabela para movimentos de serviço"
                                    text="Serviço"
                                    name="servico"
                                    handleOnChange={handleChange}
                                    value={dados.servico}
                                    checked={!!dados.servico}
                                />
                                <Checkbox
                                    title="Tabela para movimentos de Produção"
                                    text="Produção"
                                    name="producao"
                                    handleOnChange={handleChange}
                                    value={dados.producao}
                                    checked={!!dados.producao}
                                />
                                <Checkbox
                                    title="Tabela para movimentos de restaurante"
                                    text="Cardápio"
                                    name="cardapio"
                                    handleOnChange={handleChange}
                                    value={dados.cardapio}
                                    checked={!!dados.cardapio}
                                />
                                <Checkbox
                                    title="Quando marcada a opção ATIVA"
                                    text="Ativo"
                                    name="ativo"
                                    handleOnChange={handleChange}
                                    value={dados.ativo}
                                    checked={!!dados.ativo}
                                />
                                <Checkbox
                                    title="Integração ativa, o objeto será exportado para a API de integração"
                                    text="Integração Ativo"
                                    name="integracaoAtivo"
                                    handleOnChange={handleChange}
                                    value={dados.integracaoAtivo}
                                    checked={!!dados.integracaoAtivo}
                                />
                                <Checkbox
                                    title="Integração Multi-Empresa, quando marcado o objeto será exportado para a API de integração para todas as empresas do grupo"
                                    text="Integração Multi-Empresa"
                                    name="integracaoTodasEmpresas"
                                    handleOnChange={handleChange}
                                    value={dados.integracaoTodasEmpresas}
                                    checked={!!dados.integracaoTodasEmpresas}
                                />
                            </div>
                            <h4>Novos produtos na tabela de preço</h4>
                            <div>
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        marginTop: '1rem',
                                        flexWrap: 'wrap',
                                    }}
                                >
                                    <SelectEmpresa
                                        text="Empresa"
                                        name="novoProduto.empresaId"
                                        options={OptionsEmpresa}
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={novoProduto.empresaId || ''}
                                        required
                                        notOptNull={true}
                                    />
                                    <DataList
                                        text="Produto"
                                        title={'Digite para selecionar o produto'}
                                        name="novoProduto.descricao"
                                        //inputWidth="250px"
                                        filteredOptions={OptionsProduto}
                                        barcodeScanner
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={Produto?.descricao || ''}
                                    />
                                    <Select
                                        name="novoProduto.embalagemId"
                                        title={'Escolha a embalagem do produto'}
                                        text="Embalagem"
                                        options={OptionsEmbalagem}
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={novoProduto.embalagemId}
                                        isEnum={false}
                                        notOptNull={false}
                                    />
                                    <InputNumber
                                        text="Valor Total"
                                        type="text"
                                        name="novoProduto.preco"
                                        placeholder="Valor R$"
                                        inputWidth="100px"
                                        title="digite o valor total do produto para a embalagem"
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={novoProduto.preco ? formatarNumero(novoProduto.preco) : ''}
                                        readonly={!novoProduto.embalagemId}
                                    />
                                    <InputNumber
                                        text="Valor Unitário"
                                        type="text"
                                        name="novoProduto.precoUnitario"
                                        placeholder="Valor R$"
                                        inputWidth="100px"
                                        title="digite o valor unitário do produto"
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={novoProduto.precoUnitario ? formatarNumero(novoProduto.precoUnitario) : ''}
                                        readonly={!novoProduto.embalagemId}
                                    />
                                    {!dados.cardapio && (
                                        <InputNumber
                                            text="Desconto %"
                                            type="text"
                                            name="novoProduto.descontoPercentualItemTabela"
                                            placeholder="Valor %"
                                            inputWidth="100px"
                                            title="percentual de desconto permitido para o item"
                                            handleOnChange={handleChange}
                                            handleOnFocus={handleOnFocus}
                                            handleOnBlur={handleOnBlur}
                                            value={
                                                novoProduto.descontoPercentualItemTabela
                                                    ? formatarNumero(novoProduto.descontoPercentualItemTabela)
                                                    : ''
                                            }
                                            readonly={!novoProduto.embalagemId}
                                        />
                                    )}
                                    {dados.cardapio && (
                                        <>
                                            <Checkbox
                                                title="Liberado no cardapio da domingo"
                                                text="Domingo"
                                                name="novoProduto.domingo"
                                                handleOnChange={handleChange}
                                                handleOnFocus={handleOnFocus}
                                                handleOnBlur={handleOnBlur}
                                                value={novoProduto.domingo}
                                                checked={!!novoProduto.domingo}
                                            />
                                            <Checkbox
                                                title="Liberado no cardapio da seunda-feira"
                                                text="Segunda"
                                                name="novoProduto.segunda"
                                                handleOnChange={handleChange}
                                                handleOnFocus={handleOnFocus}
                                                handleOnBlur={handleOnBlur}
                                                value={novoProduto.segunda}
                                                checked={!!novoProduto.segunda}
                                            />
                                            <Checkbox
                                                title="Liberado no cardapio da terça-feira"
                                                text="Terça"
                                                name="novoProduto.terca"
                                                handleOnChange={handleChange}
                                                handleOnFocus={handleOnFocus}
                                                handleOnBlur={handleOnBlur}
                                                value={novoProduto.terca}
                                                checked={!!novoProduto.terca}
                                            />
                                            <Checkbox
                                                title="Liberado no cardapio da quarta-feira"
                                                text="Quarta"
                                                name="novoProduto.quarta"
                                                handleOnChange={handleChange}
                                                handleOnFocus={handleOnFocus}
                                                handleOnBlur={handleOnBlur}
                                                value={novoProduto.quarta}
                                                checked={!!novoProduto.quarta}
                                            />
                                            <Checkbox
                                                title="Liberado no cardapio da quinta-feira"
                                                text="Quinta"
                                                name="novoProduto.quinta"
                                                handleOnChange={handleChange}
                                                handleOnFocus={handleOnFocus}
                                                handleOnBlur={handleOnBlur}
                                                value={novoProduto.quinta}
                                                checked={!!novoProduto.quinta}
                                            />
                                            <Checkbox
                                                title="Liberado no cardapio da sexta-feira"
                                                text="Sexta"
                                                name="novoProduto.sexta"
                                                handleOnChange={handleChange}
                                                handleOnFocus={handleOnFocus}
                                                handleOnBlur={handleOnBlur}
                                                value={novoProduto.sexta}
                                                checked={!!novoProduto.sexta}
                                            />
                                            <Checkbox
                                                title="Liberado no cardapio da sábado"
                                                text="Sábado"
                                                name="novoProduto.sabado"
                                                handleOnChange={handleChange}
                                                handleOnFocus={handleOnFocus}
                                                handleOnBlur={handleOnBlur}
                                                value={novoProduto.sabado}
                                                checked={!!novoProduto.sabado}
                                            />
                                            <Checkbox
                                                title="Liberado no cardapio todo dia"
                                                text="Todos"
                                                name="novoProduto.todosDias"
                                                handleOnChange={handleChange}
                                                handleOnFocus={handleOnFocus}
                                                handleOnBlur={handleOnBlur}
                                                value={novoProduto.todosDias}
                                                checked={!!novoProduto.todosDias}
                                            />
                                            <Checkbox
                                                title="Informa que esse item é um prato o que diferencia de produtos industrializados"
                                                text="Prato"
                                                name="novoProduto.prato"
                                                handleOnChange={handleChange}
                                                handleOnFocus={handleOnFocus}
                                                handleOnBlur={handleOnBlur}
                                                value={novoProduto.prato}
                                                checked={!!novoProduto.prato}
                                            />
                                            {novoProduto.prato && (
                                                <>
                                                    {' '}
                                                    <Checkbox
                                                        title="Liberado no cardapio do café da manhã"
                                                        text="Café manhã"
                                                        name="novoProduto.cafeManha"
                                                        handleOnChange={handleChange}
                                                        handleOnFocus={handleOnFocus}
                                                        handleOnBlur={handleOnBlur}
                                                        value={novoProduto.cafeManha}
                                                        checked={!!novoProduto.cafeManha}
                                                    />
                                                    <Checkbox
                                                        title="Liberado no cardapio da almoço"
                                                        text="Almoço"
                                                        name="novoProduto.almoco"
                                                        handleOnChange={handleChange}
                                                        handleOnFocus={handleOnFocus}
                                                        handleOnBlur={handleOnBlur}
                                                        value={novoProduto.almoco}
                                                        checked={!!novoProduto.almoco}
                                                    />
                                                    <Checkbox
                                                        title="Liberado no cardapio do jantar"
                                                        text="Jantar"
                                                        name="novoProduto.jantar"
                                                        handleOnChange={handleChange}
                                                        handleOnFocus={handleOnFocus}
                                                        handleOnBlur={handleOnBlur}
                                                        value={novoProduto.jantar}
                                                        checked={!!novoProduto.jantar}
                                                    />
                                                </>
                                            )}
                                        </>
                                    )}
                                    <Checkbox
                                        title="Ativo quando marcado"
                                        text="Ativo"
                                        name="novoProduto.ativo"
                                        handleOnChange={handleChange}
                                        handleOnFocus={handleOnFocus}
                                        handleOnBlur={handleOnBlur}
                                        value={novoProduto.ativo}
                                        checked={!!novoProduto.ativo}
                                    />
                                    <Button
                                        variant="contained"
                                        color="inherit"
                                        onClick={() => {
                                            limparRow('produto');
                                        }}
                                        style={{ marginLeft: '10px' }}
                                    >
                                        Limpar
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color={novoProduto.funcao.toLocaleLowerCase() === 'deletar' ? 'error' : 'info'}
                                        onClick={() => handleProduto(novoProduto)}
                                        disabled={isDisabled}
                                        style={{ marginLeft: '5px' }}
                                    >
                                        {novoProduto.funcao}
                                    </Button>
                                </div>
                            </div>

                            <ThemeProvider theme={theme}>
                                <MaterialReactTable
                                    displayColumnDefOptions={{
                                        'mrt-row-actions': {
                                            muiTableHeadCellProps: {
                                                align: 'center',
                                            },
                                            size: 100,
                                        },
                                        'mrt-row-numbers': {
                                            enableColumnOrdering: true, //turn on some features that are usually off
                                            enableResizing: true,
                                            muiTableHeadCellProps: {
                                                sx: {
                                                    fontSize: '1.2rem',
                                                },
                                            },
                                        },
                                        'mrt-row-select': {
                                            enableColumnActions: true,
                                            enableHiding: true,
                                            size: 50,
                                        },
                                    }}
                                    enableColumnFilterModes
                                    enableGlobalFilterModes
                                    //enableColumnResizing
                                    enableColumnOrdering
                                    enableEditing
                                    renderRowActions={({ row, table }) => (
                                        <Box sx={{ display: 'flex', gap: '1rem' }}>
                                            <Tooltip arrow placement="top" title="Editar">
                                                <span>
                                                    {' '}
                                                    <IconButton
                                                        onClick={() => handleRow(row.original, row.id, 'Editar', 'produto')}
                                                        disabled={!podeEditar()}
                                                    >
                                                        <Edit />
                                                    </IconButton>
                                                </span>
                                            </Tooltip>
                                            <Tooltip arrow placement="right" title="Deletar">
                                                <span>
                                                    <IconButton
                                                        color="error"
                                                        onClick={() => handleRow(row.original, row.id, 'Deletar', 'produto')}
                                                        disabled={!podeCancelar()}
                                                    >
                                                        <Delete />
                                                    </IconButton>
                                                </span>
                                            </Tooltip>
                                        </Box>
                                    )}
                                    renderTopToolbarCustomActions={() => {
                                        const handleImprimir = async (obj) => {
                                            const response = await relatorios('tabelaPreco', 'tabelaPrecos', obj);
                                            //gera o pdf
                                            printPdf(response.data);
                                        };

                                        return (
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    gap: '8px',
                                                }}
                                            >
                                                <Tooltip arrow placement="top-end" title={`Relação de pratos`}>
                                                    <div>
                                                        <span>
                                                            <Button
                                                                color="info"
                                                                variant="contained"
                                                                disabled={!podeImprimir() || dados.cardapio !== true}
                                                                onClick={() => handleImprimir({ obj: dados, prato: true })}
                                                            >
                                                                <DinnerDiningIcon />
                                                            </Button>
                                                        </span>
                                                    </div>
                                                </Tooltip>
                                            </div>
                                        );
                                    }}
                                    columns={columns}
                                    data={itens}
                                    //enableRowSelection
                                    getRowId={(row) => row.uuid}
                                    manualFiltering
                                    manualPagination
                                    manualSorting
                                    muiToolbarAlertBannerProps={
                                        mrtItens.isError
                                            ? {
                                                  color: 'error',
                                                  children: 'Error loading data',
                                              }
                                            : undefined
                                    }
                                    onColumnFiltersChange={mrtItens.setColumnFilters}
                                    onColumnFilterFnsChange={mrtItens.setColumnFiltersMode}
                                    onGlobalFilterChange={mrtItens.setGlobalFilter}
                                    onPaginationChange={mrtItens.setPagination}
                                    onSortingChange={mrtItens.setSorting}
                                    rowCount={mrtItens.rowCount}
                                    initialState={{
                                        showColumnFilters: true,
                                        density: 'compact',
                                        //columnPinning: { left: ["mrt-row-select"] },
                                    }}
                                    state={{
                                        columnFilterFns: mrtItens.columnFilterFns,
                                        columnFilters: mrtItens.columnFilters,
                                        globalFilter: mrtItens.globalFilter,
                                        isLoading: mrtItens.isLoading,
                                        pagination: mrtItens.pagination,
                                        showAlertBanner: mrtItens.isError,
                                        showProgressBars: mrtItens.isRefetching,
                                        sorting: mrtItens.sorting,
                                    }}
                                    //positionToolbarDropZone={"top"}
                                    positionExpandColumn={'first'}
                                    positionActionsColumn={'first'}
                                    positionToolbarAlertBanner="bottom"
                                    localization={MRT_Localization_PT_BR}
                                />
                            </ThemeProvider>
                        </TabPanel>
                        <TabPanel>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginTop: '1rem',
                                }}
                            >
                                <DataList
                                    text="Operação"
                                    title={'Digite para selecionar a operação'}
                                    name="Operacao.descricao"
                                    inputWidth="250px"
                                    filteredOptions={OptionsOperacao}
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={Operacao?.descricao || ''}
                                />
                                <Button
                                    variant="contained"
                                    color="inherit"
                                    onClick={() => {
                                        limparRow('operacao');
                                    }}
                                    style={{ marginLeft: '10px' }}
                                >
                                    Limpar
                                </Button>
                                <Button
                                    variant="contained"
                                    color={novaOperacao.funcao === 'deletar' ? 'error' : 'info'}
                                    onClick={() => handleOperacao(novaOperacao)}
                                    disabled={!Operacao.descricao ? true : false}
                                    style={{ marginLeft: '5px' }}
                                >
                                    {novaOperacao.funcao}
                                </Button>
                            </div>
                            <ThemeProvider theme={theme}>
                                <MaterialReactTable
                                    displayColumnDefOptions={{
                                        'mrt-row-actions': {
                                            muiTableHeadCellProps: {
                                                align: 'center',
                                            },
                                            size: 100,
                                        },
                                        'mrt-row-numbers': {
                                            enableColumnOrdering: true, //turn on some features that are usually off
                                            enableResizing: true,
                                            muiTableHeadCellProps: {
                                                sx: {
                                                    fontSize: '1.2rem',
                                                },
                                            },
                                        },
                                        'mrt-row-select': {
                                            enableColumnActions: true,
                                            enableHiding: true,
                                            size: 50,
                                        },
                                    }}
                                    enableColumnFilterModes
                                    enableGlobalFilterModes
                                    //enableColumnResizing
                                    enableColumnOrdering
                                    enableEditing
                                    renderRowActions={({ row, table }) => (
                                        <Box sx={{ display: 'flex', gap: '1rem' }}>
                                            <Tooltip arrow placement="top" title="Editar">
                                                <span>
                                                    {' '}
                                                    <IconButton
                                                        onClick={() => handleRow(row.original, row.id, 'Editar', 'operacao')}
                                                        disabled={!podeEditar()}
                                                    >
                                                        <Edit />
                                                    </IconButton>
                                                </span>
                                            </Tooltip>
                                            <Tooltip arrow placement="right" title="Deletar">
                                                <span>
                                                    <IconButton
                                                        color="error"
                                                        onClick={() => handleRow(row.original, row.id, 'Deletar', 'operacao')}
                                                        disabled={!podeCancelar()}
                                                    >
                                                        <Delete />
                                                    </IconButton>
                                                </span>
                                            </Tooltip>
                                        </Box>
                                    )}
                                    columns={columnsOperacao}
                                    data={itensOperacao}
                                    //enableRowSelection
                                    getRowId={(row) => row.uuid}
                                    manualFiltering
                                    manualPagination
                                    manualSorting
                                    muiToolbarAlertBannerProps={
                                        mrtOperacoes.isError
                                            ? {
                                                  color: 'error',
                                                  children: 'Error loading data',
                                              }
                                            : undefined
                                    }
                                    onColumnFiltersChange={mrtOperacoes.setColumnFilters}
                                    onColumnFilterFnsChange={mrtOperacoes.setColumnFiltersMode}
                                    onGlobalFilterChange={mrtOperacoes.setGlobalFilter}
                                    onPaginationChange={mrtOperacoes.setPagination}
                                    onSortingChange={mrtOperacoes.setSorting}
                                    rowCount={mrtOperacoes.rowCount}
                                    initialState={{
                                        showColumnFilters: true,
                                        density: 'compact',
                                        //columnPinning: { left: ["mrt-row-select"] },
                                    }}
                                    state={{
                                        columnFilterFns: mrtOperacoes.columnFilterFns,
                                        columnFilters: mrtOperacoes.columnFilters,
                                        globalFilter: mrtOperacoes.globalFilter,
                                        isLoading: mrtOperacoes.isLoading,
                                        pagination: mrtOperacoes.pagination,
                                        showAlertBanner: mrtOperacoes.isError,
                                        showProgressBars: mrtOperacoes.isRefetching,
                                        sorting: mrtOperacoes.sorting,
                                    }}
                                    //positionToolbarDropZone={"top"}
                                    positionExpandColumn={'first'}
                                    positionActionsColumn={'first'}
                                    positionToolbarAlertBanner="bottom"
                                    localization={MRT_Localization_PT_BR}
                                />
                            </ThemeProvider>
                        </TabPanel>
                    </div>
                    <div>
                        <Stack direction="row" spacing={1}>
                            <Button variant="contained" color="secondary" onClick={() => navigate(caminhoVoltar)}>
                                Voltar
                            </Button>
                            <Button type="submit" variant="contained" color="success" disabled={isSubmitting}>
                                {btnText}
                            </Button>
                        </Stack>
                    </div>
                </form>
            </Tabs>
        </div>
    );
}
export default Form;
